import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["viewRegimeCard", "viewTitle", "viewRegimeCardBody", "previewCard", "editRegimeBtn", "deleteRegimeBtn", "previewTitle", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--financials--regimes--show`
    this.send_data = { current_user: {}, regime: {}, notification: {} }
    // this.doViewHtml()
  }

  doViewHtml() {
    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="viewRegimeCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 py-3" style="font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="viewTitle">Nenhum Regime Tributário Selecionado</h6>
                  </div>
                  <div class="card-body py-0 px-2" style="overflow:auto;" data-${this.controllerName}-target="viewRegimeCardBody"></div>
                </div>`

    this.controllerDash.viewTarget.innerHTML = html
  }

  editRegime() {
    this.getControllerByIdentifier("operations--products--clinics--financials--regimes--save").current_regime = this.current_regime
    this.getControllerByIdentifier("operations--products--clinics--financials--regimes--save").actionMode = "edit"
    this.getControllerByIdentifier("operations--products--clinics--financials--regimes--save").doFormHtml()
  }

  deleteRegime() {
    var r = confirm("Desejar apagar o Regime Tributário?")
    this.deleteRegimeBtnTarget.disabled = true

    if (r) {
      this.actionMode = "delete"

      this.send_data.regime.id = this.current_regime.id
      this.send_data.regime.active = false

      this.send_data.current_user.current_user_id = this.application.current_user.id

      this.send_data.notification.domain_id = this.application.clinic.id
      this.send_data.notification.domain_type = "operation_products"
      this.send_data.notification.date_id = this.application.current_date.id
      this.send_data.notification.date_type = "operation_dates"
      this.send_data.notification.kind = `mode_${this.actionMode}`
      this.send_data.notification.action = `${this.getControllerByIdentifier("app--visits--users").getUserName(this.application.current_user)} %mode_${this.actionMode}% o pagamento ${this.current_regime.chart}, no valor de ${Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 }).format(this.current_regime.amount)} para a competência de ${this.application.current_date.month_pretty}.`
      this.send_data.notification.account_name = this.application.current_user.name
      this.send_data.notification.account_id = this.application.current_user.account_id

      this.requestSave()
    } else {
      this.deleteRegimeBtnTarget.disabled = false
    }

  }

  requestSave() {

    var url = "/operations/products/clinics/regimes/update"
    var method = "PUT"
    var controller = this
    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          var regime = response.data.cln

          if (regime.active) {
            controller.application.regimes.forEach((element, i) => {
              if (element.id == regime.id) {
                controller.application.regimes.splice(controller.application.regimes.indexOf(element), 1, regime)
              }
            })
          } else {
            controller.application.regimes.forEach((element, i) => {
              if (element.id == regime.id) {
                controller.application.regimes.splice(controller.application.regimes.indexOf(element), 1)
              }
            })
          }
          controller.getControllerByIdentifier("operations--products--clinics--financials--regimes--index").doDataTable()
          controller.doViewHtml()
          controller.send_data = { current_user: {}, regime: {}, notification: {} }
        } else {
          controller.deleteRegimeBtnTarget.disabled = false
        }
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })

  }


  doRegimeHtml() {
    this.getControllerByIdentifier(`operations--products--clinics--financials--regimes--save`).stopRefreshing()
    var spaceRow = `<td colspan="10" style="height:2rem;padding-top:1rem;padding-bottom:1rem;" scope="col"></td>`

    if (this.application.permissions[this.permission].can_delete && this.application.current_date.open && this.application.current_date.has_no_receivables) {
      var deleteBtnHtml = `<button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-${this.controllerName}-target="deleteRegimeBtn" data-action="click->${this.controllerName}#deleteRegime" type="button">
                            <span class="material-icons f-1p25">delete</span>
                          </button>
                          <span class="mc-tooltiptext">Apagar Regime Tributário</span>`
    } else {
      var deleteBtnHtml = ``
    }

    // if (this.application.permissions.medclinic_regimes.can_update && this.application.current_date.open && this.application.current_date.has_no_receivables) {
    if (this.application.permissions[this.permission].can_update && this.application.current_date.open) {
      var editBtnHtml = `<button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-${this.controllerName}-target="editRegimeBtn" data-action="click->${this.controllerName}#editRegime" type="button">
                            <span class="material-icons f-1p25">edit</span>
                          </button>
                          <span class="mc-tooltiptext">Editar Regime Tributário</span>`
    } else {
      var editBtnHtml = ``
    }

    if (this.current_regime.iss_type == `aliquot`) {
      var issValue = `${this.getControllerByIdentifier("app--helpers--numbers").percentMask(Math.round(this.current_regime.iss_rate * 100))}`
    } else if (this.current_regime.iss_type == `fixed`) {
      var issValue = `${this.getControllerByIdentifier("app--helpers--numbers").currencyMask(Math.round(this.current_regime.iss_amount * 100))}`
    }


    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="previewCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4" style="padding:1rem;font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="previewTitle">Regime Tributário</h6>
                    <div class="card-actions ml-auto py-0 mc-tooltip">
                      ${editBtnHtml}
                    </div>
                    <div class="card-actions py-0 mc-tooltip">
                      ${deleteBtnHtml}
                    </div>
                  </div>
                  <div class="card-body py-0" style="overflow:auto;" data-${this.controllerName}-target="previewCardBody">
                    <div class="row my-1">
                      <div class="col-12">
                        <table class="table table-sm table-borderless" style="font-size:80%;">
                          <tbody>
                            <tr>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Regime Tributário</strong>
                              </th>
                              <td colspan="7" class="f-065 align-middle px-0 text-left">
                                ${this.current_regime.tax_regime_pretty} <br>
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Sub-regime</strong>
                              </th>
                              <td colspan="7" class="f-065 align-middle px-0 text-left">
                                ${this.current_regime.sub_tax_regime_pretty}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Natureza Legal</strong> <br>
                              </th>
                              <td colspan="7" class="f-065 align-middle px-0 text-left">
                                ${this.current_regime.legal_nature_pretty}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Regime Especial</strong> <br>
                              </th>
                              <td colspan="7" class="f-065 align-middle px-0 text-left">
                                ${this.current_regime.special_tax_regime_pretty}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Últimos 12 Meses</strong> <br>
                              </th>
                              <td colspan="7" class="f-065 align-middle px-0 text-left">
                                ${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(this.current_regime.last_twelve_months_sum)}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Mês Competência</strong> <br>
                              </th>
                              <td colspan="7" class="f-065 align-middle px-0 text-left">
                                ${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(this.current_regime.accrual_month)}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Alíquota Efetiva</strong> <br>
                              </th>
                              <td colspan="7" class="f-065 align-middle px-0 text-left">
                                ${this.getControllerByIdentifier("app--helpers--numbers").percentOptionMask(this.current_regime.effective_total_tax, { scale: 4 }) }
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>ISS</strong> <br>
                              </th>
                              <td colspan="7" class="f-065 align-middle px-0 text-left">
                                ${this.current_regime.iss_type_pretty}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Valor ISS</strong> <br>
                              </th>
                              <td colspan="7" class="f-065 align-middle px-0 text-left">
                                ${issValue}
                              </td>
                            </tr>

                            <tr>
                              ${spaceRow}
                            </tr>

                            
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.controllerDash.viewTarget.innerHTML = html)
    }).then(() => {
      controller.previewCardTarget.style.height = ($(window).height() * 0.6) + "px"
      controller.previewTitleTarget.innerText = `Regime Tributário ${controller.current_regime.accrual_date_pretty}`
      controller.getControllerByIdentifier("app--helpers--elements").tooltip()
    })

  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    this.connect()
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
